const roleAccess = {
  1: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  2: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  3: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  4: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  5: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  6: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  7: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  8: ["My Chats",'Peoples', 'Groups', 'Tickets'],
  9: ["My Chats",'Peoples', 'Groups', 'Tickets']
};

const menu =  [
  {
    key: '/chat/mychats',
    icon:'ChatOutlined',
    label: "My Chats"
  },
  {
    key: '/chat/peoples',
    icon:'ActiveUseresOutlined',
    label: "Peoples"
  },
  {
    key: '/chat/groups',
    icon:'UsersOutlined',
    label: "Groups"
  },
  {
    key: '/chat/tickets',
    icon:'IssuesOutlined',
    label: "Tickets"
  }
];
  
function getChatMenuForRoles(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus.add(item));
  });
  return menu.filter(menuItem => accessibleMenus.has(menuItem.label));
}

  
export {
  getChatMenuForRoles
};
  